import React from 'react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-gray-200 py-8" data-id="element-18">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-19">
        <p className="text-gray-500 text-sm" data-id="element-20">
          Todos los derechos reservados &copy; {new Date().getFullYear()}
        </p>
      </div>
    </footer>;
}